export function WaveArtwork({ compact = false, gold = false }: { compact?: boolean; gold?: boolean }) {
  return <div className={`wave-art ${compact ? 'wave-art--compact' : ''} ${gold ? 'wave-art--gold' : ''}`} aria-hidden="true">
    <svg viewBox="0 0 390 240" preserveAspectRatio="none">
      {[0, 1, 2, 3, 4, 5, 6].map((index) => <path key={index} d={`M-20 ${170 - index * 9} C 36 ${62 + index * 7}, 76 ${222 - index * 4}, 128 ${116 + index * 4} S 224 ${38 + index * 12}, 272 ${126 - index * 2} S 352 ${210 - index * 11}, 420 ${170 - index * 9}`} />)}
    </svg>
  </div>
}
